<section class="header">
  <section class="title-container">
    <h4 class="title">{{'NewCase.Title' | translate}}</h4>
    <hr class="separation-line" />
  </section>

  <section class="steps-container">
    <div class="numbers-container">
      <div class="number-circle" [class.disabled]="!isInitialInformationComplete()" (click)="onNavigateToTab(1)">
        1
      </div>
      <div class="number-line" [class.disabled]="!isDebtorInformationComplete()"></div>
      <div class="number-circle" [class.disabled]="!isDebtorInformationComplete()" (click)="onNavigateToTab(2)">
        2
      </div>
      <div class="number-line" [class.disabled]="!isDebtorInformationComplete() || !isInvoicesInformationComplete()">
      </div>
      <div class="number-circle" [class.disabled]="!isDebtorInformationComplete() || !isInvoicesInformationComplete()"
        (click)="onNavigateToTab(3)">
        3
      </div>
    </div>
    <div class="step-names-container">
      <span class="step-name" [class.disabled]="!isInitialInformationComplete()">
        {{'NewCase.Step1.Name' | translate}}
      </span>
      <span class="step-name" [class.disabled]="!isDebtorInformationComplete()">
        {{'NewCase.Step2.Name' | translate}}
      </span>
      <span class="step-name" [class.disabled]="!isInvoicesInformationComplete()">
        {{'NewCase.Step3.Name' | translate}}
      </span>
    </div>
  </section>
</section>

<form #form="ngForm">
  <ng-container [ngSwitch]="activeTab()">
    <section class="tab" *ngSwitchCase="0">
      <section class="left-panel">
        <h4 class="title">{{'NewCase.Step0.Title' | translate}}</h4>
        <p>{{'NewCase.Step0.Paragraph1' | translate}}</p>
        <p>{{'NewCase.Step0.Paragraph2' | translate}}</p>
        <ol>
          <li>{{'NewCase.Step0.ListItem1' | translate}}</li>
          <li>{{'NewCase.Step0.ListItem2' | translate}}</li>
          <li>{{'NewCase.Step0.ListItem3' | translate}}</li>
        </ol>
        <p>{{'NewCase.Step0.Paragraph3' | translate}}</p>
      </section>
      <section class="right-panel initial-section-container">
        <fieldset>
          <h5 class="title">{{'NewCase.ChooseCustomer' | translate}}</h5>
          <custom-select name="customerNumber" [options]="customers$ | async" [(selectedKey)]="newCase.customerNumber"
            placeholderTranslationTag="General.SelectCustomer" [searchEnabled]="true"
            (selectedKeyChange)="onCustomerChange();determineIsInformationComplete();updateReminderFeeLimit()"
            [(ngModel)]="newCase.customerNumber" #customerNumber="ngModel">
          </custom-select>
          <ng-container *ngTemplateOutlet="errorsDisplay; context: { controll: customerNumber }"></ng-container>
        </fieldset>
        <fieldset>
          <h5 class="title">{{'NewCase.SelectDebtorType' | translate}}</h5>
          <label class="custom-radio-container">
            <span class="radio-label">{{'NewCase.Person' | translate}}</span>
            <input type="radio" name="isFirm" [value]="false" [(ngModel)]="newCase.isFirm"
              (change)="updateReminderFeeLimit();onIsFirmChanged(false)">
            <span class="checkmark"></span>
          </label>
          <label class="custom-radio-container">
            <span class="radio-label">{{'NewCase.Company' | translate}}</span>
            <input type="radio" name="isFirm" [value]="true" [(ngModel)]="newCase.isFirm"
              (change)="updateReminderFeeLimit();onIsFirmChanged(true)">
            <span class="checkmark"></span>
          </label>
        </fieldset>

        <fieldset>
          <h5 class="title">{{'NewCase.CaseType' | translate}}</h5>
          <custom-select name="caseRole" [options]="caseRoles()" [(selectedKey)]="newCase.caseRole"
            [(ngModel)]="newCase.caseRole" (selectedKeyChange)="updateReminderFeeLimit()"
            [disabled]="isNewCaseTypeDropdownDisabled()">
          </custom-select>
          <ng-container *ngTemplateOutlet="errorsDisplay; context: { controll: customerNumber }"></ng-container>
        </fieldset>

        <button type="button" class="button-basic" [disabled]="!isInitialInformationComplete()"
          (click)="onNavigateToTab(1)">
          {{'NewCase.Next' | translate}}
        </button>
      </section>
    </section>
    <section class="tab" *ngSwitchCase="1">
      <section class="left-panel">
        <h4 class="title">{{'NewCase.Step' | translate}} 1</h4>
        @if (newCase.isFirm) {
        <p class="important-info">{{'NewCase.Company.Step1.Paragraph1' | translate}}</p>
        <p>{{'NewCase.Company.Step1.Paragraph2' | translate}}</p>
        <p>{{'NewCase.Company.Step1.Paragraph3' | translate}}</p>
        }
        @else {
        <p class="important-info">{{'NewCase.Person.Step1.Paragraph1' | translate}}</p>
        <p>{{'NewCase.Person.Step1.Paragraph2' | translate}}</p>
        <p class="important-info">{{'NewCase.Person.Step1.Paragraph3' | translate}}</p>
        <p>{{'NewCase.Person.Step1.Paragraph4' | translate}}</p>
        <p>{{'NewCase.Person.Step1.Paragraph5' | translate}}</p>
        <ul class="bullet-list">
          <li>{{'NewCase.Person.Step1.Paragraph6' | translate}}</li>
        </ul>
        }
      </section>

      <section class="right-panel">
        <section class="debtor-details">
          <h4 class="title full-row">{{'NewCase.DebtorInformation' | translate}}</h4>
          <div class="short-row">
            <fieldset class="short-input">
              <label class="label" [class.required]="isSocialNumberRequired()" for="socialNumber">
                {{(newCase.isFirm ? "NewCase.OrganizationNumber" : "NewCase.SocialNumber") | translate}}
              </label>
              <input type="text" class="text-input" id="socialNumber" name="socialNumber" #socialNumber="ngModel"
                [(ngModel)]="newCase.socialNumber" (focusout)="debtorInfoSearch(newCase.socialNumber, null)"
                [required]="isSocialNumberRequired()" (blur)="determineIsInformationComplete()" />
              <ng-container *ngTemplateOutlet="errorsDisplay; context: { controll: socialNumber }"></ng-container>
            </fieldset>

            <fieldset class="normal-input">
              <label for="name" class="label required">
                {{(newCase.isFirm ? "NewCase.CompanyName" : "NewCase.FirstNameSurname") | translate}}
              </label>
              <input type="text" class="text-input" id="name" name="name" #name="ngModel" [(ngModel)]="newCase.name"
                required (blur)="determineIsInformationComplete()" />
              <ng-container *ngTemplateOutlet="errorsDisplay; context: { controll: name }"></ng-container>
            </fieldset>
          </div>
          <div class="short-row">
            <fieldset class="short-input">
              <label for="customerReference1" class="label required">
                {{"NewCase.CustomerReference" | translate}}
                1
              </label>
              <input type="text" class="text-input" id="customerReference1" name="customerReference1"
                #customerReference1="ngModel" [(ngModel)]="newCase.customerReference1"
                (focusout)="debtorInfoSearch(null, newCase.customerReference1)" required
                (blur)="determineIsInformationComplete()" />
              <ng-container *ngTemplateOutlet="errorsDisplay; context: { controll: customerReference1 }"></ng-container>
            </fieldset>
            <fieldset class="short-input">
              <label for="customerReference2" class="label">{{"NewCase.CustomerReference" | translate}} 2</label>
              <input type="text" class="text-input" id="customerReference2" name="customerReference2"
                #customerReference2="ngModel" [(ngModel)]="newCase.customerReference2" />
              <ng-container *ngTemplateOutlet="errorsDisplay; context: { controll: customerReference2 }"></ng-container>
            </fieldset>
            <fieldset class="short-input">
              <label for="customerReference3" class="label">{{"NewCase.CustomerReference" | translate}} 3</label>
              <input type="text" class="text-input" id="customerReference3" name="customerReference3"
                #customerReference3="ngModel" [(ngModel)]="newCase.customerReference3" />
              <ng-container *ngTemplateOutlet="errorsDisplay; context: { controll: customerReference3 }"></ng-container>
            </fieldset>
          </div>
          <div class="full-row">
            <fieldset class="short-input">
              <label class="label required" for="countryCode">{{"NewCase.Country" | translate}}</label>
              <custom-select name="countryCode" [options]="countries$ | async" [(selectedKey)]="newCase.countryCode"
                [searchEnabled]="true" [(ngModel)]="newCase.countryCode"
                (selectedKeyChange)="determinePostCodeRestrictions()"></custom-select>
            </fieldset>
          </div>
          <div class="full-row">
            <fieldset class="normal-input">
              <label for="address1" class="label required">{{"NewCase.Address1" | translate}}</label>
              <input type="text" class="text-input" id="address1" name="address1" #address1="ngModel"
                [(ngModel)]="newCase.address1" required (blur)="determineIsInformationComplete()" />
              <ng-container *ngTemplateOutlet="errorsDisplay; context: { controll: address1 }"></ng-container>
            </fieldset>
            <fieldset class="normal-input">
              <label class="label" for="address2">{{"NewCase.Address2" | translate}}</label>
              <input type="text" class="text-input" id="address2" name="address2" #address2="ngModel"
                [(ngModel)]="newCase.address2" />
              <ng-container *ngTemplateOutlet="errorsDisplay; context: { controll: address2 }"></ng-container>
            </fieldset>
          </div>
          <div class="full-row">
            <fieldset class="normal-input">
              <label class="label" for="address3">{{"NewCase.Address3" | translate}}</label>
              <input type="text" class="text-input" id="address3" name="address3" #address3="ngModel"
                [(ngModel)]="newCase.address3" />
              <ng-container *ngTemplateOutlet="errorsDisplay; context: { controll: address3 }"></ng-container>
            </fieldset>
            <fieldset class="short-input">
              <label for="postCode" class="label" [class.required]="isPostCodeRequired()">
                {{ "NewCase.PostCode" | translate }}
              </label>
              <input type="text" class="text-input" id="postCode" name="postCode" #postCode="ngModel"
                [(ngModel)]="newCase.postCode" [attr.maxLength]="postCodeMaxLength()" [required]="isPostCodeRequired()"
                (blur)="determineIsInformationComplete()" />
              <ng-container *ngTemplateOutlet="errorsDisplay; context: { controll: postCode }"></ng-container>
            </fieldset>
          </div>
          <div class="full-row">
            <fieldset class="normal-input">
              <label class="label" for="emailAddress">{{"NewCase.EmailAddress" | translate}}</label>
              <input type="text" class="text-input" id="emailAddress" name="emailAddress" #emailAddress="ngModel"
                [(ngModel)]="newCase.emailAddress" email />
              <ng-container *ngTemplateOutlet="errorsDisplay; context: { controll: emailAddress }"></ng-container>
            </fieldset>
            <fieldset class="short-input">
              <label class="label" for="phoneNumber">
                {{"NewCase.PhoneNumber" | translate}}
                <i class="fa fa-info-circle" aria-hidden="true"
                  [matTooltip]="'NewCase.PhoneNumberForeign' | translate"></i>
              </label>
              <input type="text" class="text-input" id="phoneNumber" name="phoneNumber" #phoneNumber="ngModel"
                [(ngModel)]="newCase.phoneNumber" />
              <ng-container *ngTemplateOutlet="errorsDisplay; context: { controll: phoneNumber }"></ng-container>
            </fieldset>
          </div>
        </section>

        <section class="fees-details">
          @if (canAddCustomerReminderFee() && !isDisplayedEuFeeAndReminderFeeInSecondStep() && !isPerInvoiceReminder())
          {
          <fieldset>
            <label class="label" for="customerReminderFee">{{'NewCase.CustomerReminderFee' | translate }}</label>
            <p-inputNumber [(ngModel)]="newCase.customerReminderFee" mode="decimal" [minFractionDigits]="2"
              [maxFractionDigits]="2" [useGrouping]="false" [max]="maxCustomerReminderFeeSignal()"
              name="customerReminderFee" #customerReminderFee="ngModel">
            </p-inputNumber>

            @if(shouldDisplayMaximumReminderFee())
            {
            <div class="info">
              {{ maxReminderFeeInfoSignal() }}
            </div>
            }
            <ng-container *ngTemplateOutlet="errorsDisplay; context: { controll: customerReminderFee }"></ng-container>
          </fieldset>
          }

          @if (canAddEuFee() && newCase.isFirm && !isDisplayedEuFeeAndReminderFeeInSecondStep() &&
          !isPerInvoiceReminder()) {
          <fieldset>
            <label class="label" for="euFee">{{'NewCase.EuFee' | translate }}</label>
            <p-inputNumber [(ngModel)]="newCase.euFee" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2"
              [useGrouping]="false" name="euFee" #euFee="ngModel">
            </p-inputNumber>
            <ng-container *ngTemplateOutlet="errorsDisplay; context: { controll: euFee }"></ng-container>
          </fieldset>
          }
        </section>
        <div class="buttons-container">
          <button class="button-basic-reverse" type="button" (click)="onNavigateToTab(0)">
            {{ 'NewCase.Previous' | translate }}
          </button>
          <button type="button" class="button-basic" [disabled]="!isDebtorInformationComplete()"
            (click)="onNavigateToTab(2)">
            {{'NewCase.Next' | translate}}
          </button>
        </div>
      </section>
    </section>

    <section class="tab" *ngSwitchCase="2">
      <section class="left-panel">
        <h4 class="title">{{'NewCase.Step' | translate}} 2</h4>
        <p>{{'NewCase.Step2.Paragraph1' | translate}}</p>

        @if (newCase.isFirm){
        <p class="important-info">
          {{'NewCase.Company.Step2.Title1' | translate}}
        </p>
        <p>{{'NewCase.Company.Step2.Paragraph2' | translate}}</p>
        <p class="important-info">
          {{'NewCase.Company.Step2.Title2' | translate}}
        </p>
        <p>{{'NewCase.Company.Step2.Paragraph3' | translate}}</p>
        <p class="important-info">
          {{'NewCase.Company.Step2.Title3' | translate}}
        </p>
        <p>{{'NewCase.Company.Step2.Paragraph4' | translate}}</p>
        }
        @else {
        <p class="important-info">
          {{'NewCase.Person.Step2.Title1' | translate}}
        </p>
        <p>{{'NewCase.Person.Step2.Paragraph2' | translate}}</p>
        <p class="important-info">
          {{'NewCase.Person.Step2.Title2' | translate}}
        </p>
        <p>{{'NewCase.Person.Step2.Paragraph3' | translate}}</p>
        <p>{{'NewCase.Person.Step2.Paragraph4' | translate}}</p>
        <ul class="bullet-list">
          <li>{{'NewCase.Person.Step2.ListItem1' | translate}}</li>
          <li>{{'NewCase.Person.Step2.ListItem2' | translate}}</li>
        </ul>

        <p class="important-info">
          {{'NewCase.Person.Step2.Title3' | translate}}
        </p>
        <p>{{'NewCase.Person.Step2.Paragraph5' | translate}}</p>
        <p class="important-info">
          {{'NewCase.Person.Step2.Title4' | translate}}
        </p>
        <p>{{'NewCase.Person.Step2.Paragraph6' | translate}}</p>
        }
      </section>
      <section class="right-panel">
        <h4 class="title">{{'NewCase.Step2.Title' | translate}}</h4>
        <section class="invoice-details" [class.has-interest]="customInvoiceInterest()"
          [class.has-invoice-reminder]="showInvoiceReminderColumns()">
          <ul class="errors" *ngIf="invoicesErrors?.length">
            <li *ngFor="let errorCode of invoicesErrors">{{ ('NewCase.Invoices.' + errorCode) | translate}}</li>
          </ul>

          @if(errorsPersonDebtCollectionNotice().length > 0){
          <ul class="errors centered-text">
            @for(errorCode of errorsPersonDebtCollectionNotice(); track errorCode){
            <li>{{ errorCode | translate}}</li>
            }
          </ul>
          }

          @if(errorsCompanyDebtCollectionNotice().length > 0){
          <ul class="errors centered-text">
            @for(errorCode of errorsCompanyDebtCollectionNotice(); track errorCode){
            <li>{{ errorCode | translate :{customDays: reminderPaymentDays()} }}</li>
            }
          </ul>
          }

          <div class="invoices-table">
            @if (!isSmallScreen) {
            <div class="invoices-header">
              <label class="label required">{{ "NewCase.Invoice.Date" | translate }}</label>
              <label class="label required">{{ "NewCase.Invoice.DueDate" | translate }}</label>
              <label class="label required">{{ "NewCase.Invoice.Number" | translate }}</label>
              <label class="label required">{{ "NewCase.Invoice.Amount" | translate }}</label>
              <label class="label required">{{ "NewCase.Invoice.Currency" | translate }}</label>
              @if (customInvoiceInterest()) {
              <label class="label">{{ "NewCase.Invoice.Interest" | translate }}</label>
              }
              @if (showInvoiceReminderColumns()) {
              <label class="label">{{ "NewCase.CustomerReminderFee" | translate }}</label>
              <label class="label">{{ "NewCase.Step2.DateOfReminder" | translate }}</label>
              }
            </div>
            }

            <ng-container *ngFor="let invoice of newCase.invoices; index as i" [ngModelGroup]="'invoices[' + i + ']'">
              <div class="invoices-group">
                @if (isSmallScreen) {
                <div class="invoices-header">
                  <label class="label required">{{ "NewCase.Invoice.Date" | translate }}</label>
                  <label class="label required">{{ "NewCase.Invoice.DueDate" | translate }}</label>
                  <label class="label required">{{ "NewCase.Invoice.Number" | translate }}</label>
                  <label class="label required">{{ "NewCase.Invoice.Amount" | translate }}</label>
                  <label class="label required">{{ "NewCase.Invoice.Currency" | translate }}</label>
                  @if (customInvoiceInterest()) {
                  <label class="label">{{ "NewCase.Invoice.Interest" | translate }}</label>
                  }
                  @if (showInvoiceReminderColumns()) {
                  <label class="label">{{ "NewCase.CustomerReminderFee" | translate }}</label>
                  <label class="label" [class.required]="isInvoiceReminderDateRequired(invoice)">{{
                    "NewCase.Step2.DateOfReminder" | translate }}</label>
                  }
                </div>
                }

                <div class="invoices-rows">
                  <fieldset autocomplete="off">
                    <p-datepicker id="date" name="date" [ngModel]="invoice.date | jsonDateParse"
                      (ngModelChange)="invoice.date=$event" #date="ngModel" [dateFormat]="locale.calendar.dateFormat"
                      [placeholder]="locale.calendar.dateFormatPlaceholder" (onBlur)="onInvoiceFieldLeave()" required>
                    </p-datepicker>
                    <ng-container *ngTemplateOutlet="errorsDisplay; context: { controll: date }"></ng-container>
                  </fieldset>

                  <fieldset autocomplete="off">
                    <p-datepicker id="dueDate" name="dueDate" [ngModel]="invoice.dueDate | jsonDateParse"
                      (ngModelChange)="invoice.dueDate=$event;setMinDateOfReminder()" #dueDate="ngModel"
                      [dateFormat]="locale.calendar.dateFormat" [placeholder]="locale.calendar.dateFormatPlaceholder"
                      (onBlur)="onInvoiceFieldLeave()" required>
                    </p-datepicker>
                    <ng-container *ngTemplateOutlet="  errorsDisplay;  context: { controll: dueDate }"></ng-container>
                  </fieldset>
                  <fieldset>
                    <input type="text" class="text-input" id="number" name="number" #number="ngModel"
                      [(ngModel)]="invoice.number" (blur)="onInvoiceFieldLeave()" required />
                    <ng-container *ngTemplateOutlet="errorsDisplay;context: { controll: number }"></ng-container>
                  </fieldset>
                  <fieldset>
                    <p-inputNumber [(ngModel)]="invoice.amount" #amount="ngModel" inputId="amount" name="amount"
                      mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [useGrouping]="false"
                      (onBlur)="onInvoiceFieldLeave('amount')" required>
                    </p-inputNumber>
                    <ng-container *ngTemplateOutlet="errorsDisplay;  context: { controll: amount }"></ng-container>
                  </fieldset>
                  <fieldset>
                    <custom-select name="currencyCode" [options]="currencyCodes$ | async"
                      [(selectedKey)]="invoice.currencyCode" [searchEnabled]="true" [(ngModel)]="invoice.currencyCode">
                    </custom-select>
                  </fieldset>
                  @if (customInvoiceInterest()) {
                  <fieldset>
                    <p-inputNumber [(ngModel)]="invoice.interestRate" #interestRate="ngModel" inputId="interestRate"
                      name="interestRate" [min]="0" [max]="99.9" mode="decimal" [minFractionDigits]="1"
                      [maxFractionDigits]="1" [useGrouping]="false" (onBlur)="onInvoiceFieldLeave('interestRate')"
                      [required]="isInterestRateRequired()">
                    </p-inputNumber>
                    <ng-container
                      *ngTemplateOutlet="errorsDisplay;  context: { controll: interestRate }"></ng-container>
                  </fieldset>
                  }
                  @if (showInvoiceReminderColumns()) {
                  <fieldset>
                    <p-inputNumber [ngModel]="invoice.customerReminderFee"
                      (ngModelChange)="onInvoiceReminderFeeChange(invoice, $event)" #customerReminderFee="ngModel"
                      inputId="customerReminderFee" name="customerReminderFee" mode="decimal" [minFractionDigits]="2"
                      [maxFractionDigits]="2" [useGrouping]="false" [min]="0" [max]="maxCustomerReminderFeeSignal()"
                      (onBlur)="onInvoiceFieldLeave()">
                    </p-inputNumber>
                    <ng-container
                      *ngTemplateOutlet="errorsDisplay;  context: { controll: customerReminderFee }"></ng-container>
                  </fieldset>
                  <fieldset autocomplete="off">
                    <div class="invoice-reminder-date">
                      <p-datepicker name="customerReminderDueDate"
                        [ngModel]="invoice.customerReminderDueDate | jsonDateParse"
                        (ngModelChange)="invoice.customerReminderDueDate=$event;onInvoiceFieldLeave()"
                        #customerReminderDueDate="ngModel" [dateFormat]="locale.calendar.dateFormat"
                        [placeholder]="locale.calendar.dateFormatPlaceholder"
                        [disabled]="invoice.customerReminderFee == null" [minDate]="invoiceReminderBounds()[i]?.min"
                        [maxDate]="invoiceReminderBounds()[i]?.max">
                      </p-datepicker>
                      @if (!isSmallScreen && isInvoiceReminderDateRequired(invoice)) {
                      <span class="required"></span>
                      }
                    </div>
                    <ng-container
                      *ngTemplateOutlet="errorsDisplay;  context: { controll: customerReminderDueDate }"></ng-container>
                  </fieldset>
                  }
                  <fieldset>
                    <button class="floating-round-button floating-add mr-2" *ngIf="i + 1 === newCase.invoices?.length"
                      (click)="onAddInvoice()">
                      <i class="fas fa-plus"></i>
                    </button>
                    <button class="floating-round-button floating-delete" *ngIf="i > 0 || newCase.invoices?.length > 1"
                      (click)="onRemoveInvoice(i)">
                      <i class="fas fa-trash"></i>
                    </button>
                  </fieldset>
                </div>

                @if (invoiceReminderErrors()[i]?.length) {
                <ul class="errors">
                  @for (errorCode of invoiceReminderErrors()[i]; track errorCode) {
                  <li>{{ errorCode | translate :{customDays: reminderPaymentDays()} }}</li> }
                </ul>
                }
              </div>
            </ng-container>
          </div>

          <label class="total-label">
            {{ 'NewCase.Invoices.Total' | translate }} :
            {{ invoicesTotal | number : locale.numberPipeFormat.style : locale.numberPipeFormat.culture}}
          </label>

          @if (showInvoiceReminderColumns() && shouldDisplayMaximumReminderFee()) {
          <div class="info">
            {{ maxReminderFeeInfoSignal() }}
          </div>
          }
        </section>

        <section class="invoice-copies">
          <div class="invoice-copies-header">
            <i class="fa fa-info-circle" [matTooltip]="'NewCase.InvoiceCopiesInfo' | translate"></i>
            <label class="label required">
              {{'NewCase.UploadInvoiceCopies' | translate}}
            </label>
            <i class="fas fa-cloud-upload-alt cursor-pointer" (click)="openInvoiceCopyMatchingDialog()"></i>
          </div>
          <div *ngFor="let invoice of newCase.invoices" class="invoice-copies-list">
            <ng-container *ngIf="invoice.invoiceCopyName?.length > 0">
              <span>
                {{invoice.number}}
              </span>
              <span>
                {{invoice.invoiceCopyName}}
              </span>
              <i class="fas fa-times" (click)="onRemoveInvoiceCopy(invoice)"></i>
            </ng-container>
          </div>
        </section>

        <section class="other-details">
          <fieldset>
            <label class="label required" for="invoiceDescription">
              {{ 'NewCase.InvoiceDescription' | translate }}
            </label>
            <input type="text" class="text-input" id="invoicesDescription" name="invoicesDescription"
              #invoicesDescription="ngModel" [(ngModel)]="newCase.invoicesDescription"
              (blur)="determineIsInformationComplete()" />
            <ng-container *ngTemplateOutlet="errorsDisplay;context: { controll: invoicesDescription }"></ng-container>
          </fieldset>
          <div class="questions-row">
            @if (displayRoadFreightQuestion()) {
            <fieldset>
              <label class="label required" for="isRoadFreight">
                {{ 'NewCase.IsRoadFreight' | translate }}
              </label>
              <custom-select name="isRoadFreight" [options]="yesNoSelection"
                [(selectedKey)]="newCase.isRoadFreight"></custom-select>
            </fieldset>
            }
            <fieldset>
              <label class="label required" for="debtorHasObjections">
                {{ 'NewCase.DebtorHasObjections' | translate }}
              </label>
              <custom-select name="debtorHasObjections" [options]="yesNoSelection"
                [(selectedKey)]="newCase.debtorHasObjections" [(ngModel)]="newCase.debtorHasObjections"
                (selectedKeyChange)="determineIsInformationComplete();clearAdditionalInfo()"></custom-select>
            </fieldset>
          </div>

          @if(newCase.debtorHasObjections){
          <fieldset class="additional-details-container">
            <ng-container>
              <label class="label required" for="additionalDetails">
                {{"NewCase.AdditionalDetails" | translate}}
              </label>
              <textarea id="additionalDetails" class="text-input" name="additionalDetails" #additionalDetails="ngModel"
                [(ngModel)]="newCase.additionalDetails" (input)="determineIsInformationComplete()"></textarea>
              <ng-container *ngTemplateOutlet="errorsDisplay;  context: { controll: additionalDetails }"></ng-container>
            </ng-container>
          </fieldset>
          }

          <!-- Finland: the reminder fee and date are entered per invoice instead -->
          @if (!isPerInvoiceReminder()) {
          @if(!newCase.isFirm && newCase.caseRole == 'Collection'){
          <div>
            <!-- Reminder payment deadline field -->
            <div class="questions-row">
              <fieldset>
                <label class="label required" for="debtorHasReminderWithPaymentDeadline">
                  {{ 'NewCase.Step2.HasReminderWithPaymentDeadline' | translate }}
                </label>
                <custom-select [disabled]="collectionReminderCompulsorySignal()"
                  name="debtorHasReminderWithPaymentDeadline" [options]="yesNoSelection"
                  [(selectedKey)]="newCase.debtorHasReminderWithPaymentDeadline"
                  [(ngModel)]="newCase.debtorHasReminderWithPaymentDeadline"
                  (selectedKeyChange)="whenReminderWithPaymentDeadlineChange()">
                </custom-select>
              </fieldset>

              @if(newCase.debtorHasReminderWithPaymentDeadline){
              <!-- Date of Reminder field -->
              <fieldset class="date-reminder-wrapper">
                <label class="label required" for="dateOfReminder">{{ "NewCase.Step2.DateOfReminder" | translate
                  }}</label>
                <p-datepicker id="dateOfReminder" name="dateOfReminder"
                  [ngModel]="newCase.dateOfReminder | jsonDateParse"
                  (ngModelChange)="newCase.dateOfReminder = $event;checkReminderNoticeDateWhenPerson(newCase.dateOfReminder);determineIsInformationComplete()"
                  #dateOfReminder="ngModel" [dateFormat]="locale.calendar.dateFormat"
                  [placeholder]="locale.calendar.dateFormatPlaceholder" [minDate]="minDateOfReminder" required>
                </p-datepicker>
                <ng-container
                  *ngTemplateOutlet="  errorsDisplay;  context: { controll: dateOfReminder }"></ng-container>
              </fieldset>
              }
            </div>

            @if(newCase.debtorHasReminderWithPaymentDeadline){
            <!-- Reminder included fee field  -->
            <div class="questions-row">
              <fieldset>
                <label class="label required" for="debtorHasReminderIncludedFee">
                  {{ 'NewCase.Step2.ReminderIncludedFee' | translate }}
                </label>
                <custom-select class="width-selector" name="debtorHasReminderIncludedFee" [options]="yesNoSelection"
                  [(selectedKey)]="newCase.debtorHasReminderIncludedFee"
                  [(ngModel)]="newCase.debtorHasReminderIncludedFee"
                  (selectedKeyChange)="determineIsInformationComplete()">
                </custom-select>
              </fieldset>
            </div>
            }
          </div>
          }

          @if(newCase.isFirm && newCase.caseRole == 'Collection'){
          <div>
            <!-- Reminder payment deadline field -->
            <div class="questions-row">
              <fieldset>
                <label class="label required" for="debtorHasReminderWithPaymentDeadline">
                  {{ (hasReminderWithCustomDaysPayment() ? 'NewCase.Step2.HasReminderWithXDaysPaymentDeadline' :
                  'NewCase.Step2.HasReminderWithPaymentDeadline') | translate : {customDays: reminderPaymentDays()} }}
                </label>
                <custom-select name="debtorHasReminderWithPaymentDeadline" [options]="yesNoSelection"
                  [(selectedKey)]="newCase.debtorHasReminderWithPaymentDeadline"
                  [(ngModel)]="newCase.debtorHasReminderWithPaymentDeadline"
                  (selectedKeyChange)="whenReminderWithPaymentDeadlineChange()">
                </custom-select>
              </fieldset>

              @if(newCase.debtorHasReminderWithPaymentDeadline){
              <!-- Date of Reminder field -->
              <fieldset class="date-reminder-wrapper">
                <label class="label required" for="dateOfReminder">{{ "NewCase.Step2.DateOfReminder" | translate
                  }}</label>
                <p-datepicker id="dateOfReminder" name="dateOfReminder"
                  [ngModel]="newCase.dateOfReminder | jsonDateParse"
                  (ngModelChange)="newCase.dateOfReminder = $event;checkReminderNoticeDateWhenCompany(newCase.dateOfReminder);determineIsInformationComplete()"
                  #dateOfReminder="ngModel" [dateFormat]="locale.calendar.dateFormat"
                  [placeholder]="locale.calendar.dateFormatPlaceholder" [minDate]="minDateOfReminder" required>
                </p-datepicker>
                <ng-container
                  *ngTemplateOutlet="  errorsDisplay;  context: { controll: dateOfReminder }"></ng-container>
              </fieldset>
              }
            </div>

            @if((newCase.debtorHasReminderWithPaymentDeadline && canReminderIncludeReminderFeeAndEuFee()) ||
            (newCase.debtorHasReminderWithPaymentDeadline && !newCase.hasDebtCollectionNoticeEUFee)){
            <!-- Reminder included fee field  -->
            <div class="questions-row">
              <fieldset>
                <label class="label required" for="debtorHasReminderIncludedFee">
                  {{ 'NewCase.Step2.ReminderIncludedFee' | translate }}
                </label>
                <custom-select class="width-selector" name="debtorHasReminderIncludedFee" [options]="yesNoSelection"
                  [(selectedKey)]="newCase.debtorHasReminderIncludedFee"
                  [(ngModel)]="newCase.debtorHasReminderIncludedFee"
                  (selectedKeyChange)="whenDebtorHasReminderIncludedFeeChange();determineIsInformationComplete()">
                </custom-select>
              </fieldset>
            </div>
            }

            @if((newCase.debtorHasReminderWithPaymentDeadline && canReminderIncludeReminderFeeAndEuFee()) ||
            (newCase.debtorHasReminderWithPaymentDeadline && !newCase.debtorHasReminderIncludedFee)){
            <!-- Debt collection notice include an EU fee field  -->
            <div class="questions-row">
              <fieldset>
                <label class="label required" for="hasDebtCollectionNoticeEUFee">
                  {{ 'NewCase.Step2.HasDebtCollectionNoticeEUFee' | translate }}
                </label>
                <custom-select class="width-selector" name="hasDebtCollectionNoticeEUFee" [options]="yesNoSelection"
                  [(selectedKey)]="newCase.hasDebtCollectionNoticeEUFee"
                  [(ngModel)]="newCase.hasDebtCollectionNoticeEUFee"
                  (selectedKeyChange)="whenHasDebtCollectionNoticeEUFeeChange();determineIsInformationComplete()">
                </custom-select>
              </fieldset>
            </div>
            }
          </div>
          }

          @if(newCase.caseRole == 'Reminder' && canCollectFeesInReminderSignal()){
          <div class="questions-row">
            <fieldset>
              <label class="label required" for="debtorHasReminderWithPaymentDeadline">
                {{ 'NewCase.Step2.ReminderWasSentByCustomer' | translate }}
              </label>
              <custom-select name="debtorHasReminderWithPaymentDeadline" [options]="yesNoSelection"
                [(selectedKey)]="newCase.debtorHasReminderWithPaymentDeadline"
                [(ngModel)]="newCase.debtorHasReminderWithPaymentDeadline"
                (selectedKeyChange)="whenReminderWithPaymentDeadlineChange()">
              </custom-select>
            </fieldset>
          </div>

          @if(newCase.debtorHasReminderWithPaymentDeadline){
          <!-- Reminder included fee field  -->
          <div class="questions-row">
            <fieldset>
              <label class="label required" for="debtorHasReminderIncludedFee">
                {{ 'NewCase.Step2.ReminderIncludedFee' | translate }}
              </label>
              <custom-select class="width-selector" name="debtorHasReminderIncludedFee" [options]="yesNoSelection"
                [(selectedKey)]="newCase.debtorHasReminderIncludedFee"
                [(ngModel)]="newCase.debtorHasReminderIncludedFee"
                (selectedKeyChange)="whenDebtorHasReminderIncludedFeeChange();determineIsInformationComplete()">
              </custom-select>
            </fieldset>
          </div>
          }

          @if(newCase.debtorHasReminderWithPaymentDeadline && newCase.isFirm && (!newCase.debtorHasReminderIncludedFee
          || canReminderIncludeReminderFeeAndEuFee())){
          <!-- Debt collection notice include an EU fee field -->
          <div class="questions-row">
            <fieldset>
              <label class="label required" for="hasDebtCollectionNoticeEUFee">
                {{ 'NewCase.Step2.HasDebtCollectionNoticeEUFee' | translate }}
              </label>
              <custom-select class="width-selector" name="hasDebtCollectionNoticeEUFee" [options]="yesNoSelection"
                [(selectedKey)]="newCase.hasDebtCollectionNoticeEUFee"
                [(ngModel)]="newCase.hasDebtCollectionNoticeEUFee"
                (selectedKeyChange)="whenHasDebtCollectionNoticeEUFeeChange();determineIsInformationComplete()">
              </custom-select>
            </fieldset>
          </div>
          }
          }
          }

          <label class="custom-checkbox-container required">
            <input type="checkbox" class="column-checkbox" id="verification1" [(ngModel)]="verification1"
              [ngModelOptions]="{standalone: true}" (ngModelChange)="determineIsInformationComplete()">
            <span class="checkmark"></span>
            <label for="verification1">{{ 'NewCase.Step2.VerificationCheckbox1' | translate}}</label>
          </label>

          @if (!newCase.isFirm) {
          <label class="custom-checkbox-container required">
            <input type="checkbox" class="column-checkbox" id="verification2" [(ngModel)]="verification2"
              [ngModelOptions]="{standalone: true}" (ngModelChange)="determineIsInformationComplete()">
            <span class="checkmark"></span>
            <label for="verification2">{{ 'NewCase.Step2.VerificationCheckbox2' | translate}}</label>
          </label>
          <label class="custom-checkbox-container">
            <input type="checkbox" class="column-checkbox" id="verification3" [(ngModel)]="verification3"
              [ngModelOptions]="{standalone: true}" (ngModelChange)="determineIsInformationComplete()">
            <span class="checkmark"></span>
            <label for="verification3">
              {{ 'NewCase.Step2.VerificationCheckbox3' | translate}}
              <span class="required"></span>
            </label>
          </label>

          @if(newCase.caseRole == 'Collection' && newCase.debtorHasReminderWithPaymentDeadline){
          <label class="custom-checkbox-container">
            <input type="checkbox" class="column-checkbox" id="verification4" [(ngModel)]="verification4"
              [ngModelOptions]="{standalone: true}" (ngModelChange)="determineIsInformationComplete()">
            <span class="checkmark"></span>
            <label for="verification4">
              {{ 'NewCase.Step2.VerificationCheckbox4' | translate}}
              <span class="required"></span>
            </label>
          </label>
          }
          }

          @if(newCase.isFirm && newCase.caseRole == 'Reminder'){
          <label class="custom-checkbox-container">
            <input type="checkbox" class="column-checkbox" id="verification5" [(ngModel)]="verification5"
              [ngModelOptions]="{standalone: true}" (ngModelChange)="determineIsInformationComplete()">
            <span class="checkmark"></span>
            <label for="verification5">
              {{ 'NewCase.Step2.ConfirmCapitalMeetsSection9Act' | translate}}
              <span class="required"></span>
            </label>
          </label>
          }

          <div class="fees-details fees-details-step2-align-items">
            @if (canAddCustomerReminderFee() && isDisplayedEuFeeAndReminderFeeInSecondStep() &&
            newCase.debtorHasReminderIncludedFee && !isPerInvoiceReminder()) {
            <fieldset>
              <label class="label" for="customerReminderFee">{{'NewCase.CustomerReminderFee' | translate }}</label>
              <p-inputNumber [(ngModel)]="newCase.customerReminderFee" mode="decimal" [minFractionDigits]="2"
                [maxFractionDigits]="2" [useGrouping]="false" [max]="maxCustomerReminderFeeSignal()"
                name="customerReminderFee" #customerReminderFee="ngModel">
              </p-inputNumber>

              @if(shouldDisplayMaximumReminderFee())
              {
              <div class="info">
                {{ maxReminderFeeInfoSignal() }}
              </div>
              }
              <ng-container
                *ngTemplateOutlet="errorsDisplay; context: { controll: customerReminderFee }"></ng-container>
            </fieldset>
            }

            @if (showStepTwoEuFee()) {
            <fieldset>
              <label class="label" for="euFee">{{'NewCase.EuFee' | translate }}</label>
              <p-inputNumber [(ngModel)]="newCase.euFee" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2"
                [useGrouping]="false" name="euFee" #euFee="ngModel" (onBlur)="determineIsInformationComplete()">
              </p-inputNumber>
              <ng-container *ngTemplateOutlet="errorsDisplay; context: { controll: euFee }"></ng-container>
              @if (!isFinlandEuFeeValid()) {
              <ul class="errors">
                <li>{{ 'NewCase.Step2.FeeMustBeGreaterThanZero' | translate }}</li>
              </ul>
              }
            </fieldset>
            }
          </div>
        </section>

        <div class="buttons-container">
          <button class="button-basic-reverse" type="button" (click)="onNavigateToTab(1)">
            {{ 'NewCase.Previous' | translate }}
          </button>
          <button class="button-basic" type="button" (click)="onNavigateToTab(3)"
            [disabled]="!isInvoicesInformationComplete()">
            {{ 'NewCase.Next' | translate }}
          </button>
        </div>
      </section>
    </section>
    <section class="tab" *ngSwitchCase="3">
      <section class="left-panel">
        <h4 class="title">{{'NewCase.Step' | translate}} 3</h4>
        <p>{{'NewCase.Step3.Paragraph1' | translate}}</p>
      </section>
      <section class="right-panel" id="dataReview">
        <div>
          <h4 class="title">{{'NewCase.Step3.Name' | translate}}</h4>
          <div class="customer-summary-container">
            <h5 class="title">
              {{'NewCase.Customer' | translate}}
            </h5>
            <label class="property-value">
              {{ newCase.customerNumber}}&nbsp;-&nbsp;{{selectedCustomerSignal()?.name }}
            </label>
          </div>
          <div class="summary-tab">
            <div class="summary-tab-left">
              <section class="debtor-info-summary">
                <h5 class="title">
                  {{ 'NewCase.DebtorInformation' | translate }}
                </h5>
                <div>
                  <label>
                    {{ 'NewCase.Type' | translate}}:
                  </label>
                  <span class="property-value">
                    {{(newCase.isFirm ? 'NewCase.Company' : 'NewCase.Person') | translate}}
                  </span>
                </div>
                <div>
                  <label>
                    {{'NewCase.Name' | translate}}:
                  </label>
                  <span class="property-value">
                    {{ newCase.name }}
                  </span>
                </div>
                <div>
                  <label>
                    {{(newCase.isFirm ? 'NewCase.OrganizationNumber' : 'NewCase.SocialNumber') | translate}}:
                  </label>
                  <span class="property-value">
                    {{ newCase.socialNumber }}
                  </span>
                </div>
                <div>
                  <label>
                    {{ 'NewCase.Country' | translate}}:
                  </label>
                  <span class="property-value">
                    {{ newCase.countryCode }}
                  </span>
                </div>
                <div>
                  <label>
                    {{ 'NewCase.Address1' | translate}}:
                  </label>
                  <span class="property-value">
                    {{ newCase.address1}}
                  </span>
                </div>
                @if (newCase.address2?.length) {
                <div>
                  <label>
                    {{ 'NewCase.Address2' | translate}}:
                  </label>
                  <span class="property-value">
                    {{ newCase.address2 }}
                  </span>
                </div>
                }
                @if (newCase.address3?.length) {
                <div>
                  <label>
                    {{ 'NewCase.Address3' | translate}}:
                  </label>
                  <span class="property-value">
                    {{ newCase.address3 }}
                  </span>
                </div>
                }
                <div>
                  <label>
                    {{ 'NewCase.PostCode' | translate}}:
                  </label>
                  <span class="property-value">
                    {{ newCase.postCode }}
                  </span>
                </div>
                @if (newCase.phoneNumber?.length) {
                <div>
                  <label>
                    {{ 'NewCase.PhoneNumber' | translate}}:
                  </label>
                  <span class="property-value">
                    {{ newCase.phoneNumber }}
                  </span>
                </div>
                }
                @if (newCase.emailAddress?.length) {
                <div>
                  <label>
                    {{ 'NewCase.EmailAddress' | translate}}:
                  </label>
                  <span class="property-value">
                    {{ newCase.emailAddress }}
                  </span>
                </div>
                }
                <div>
                  <label>
                    {{ 'NewCase.CustomerReference' | translate}} 1:
                  </label>
                  <span class="property-value">
                    {{ newCase.customerReference1 }}
                  </span>
                </div>
                @if (newCase.customerReference2?.length) {
                <div>
                  <label>
                    {{ 'NewCase.CustomerReference' | translate}} 2:
                  </label>
                  <span class="property-value">
                    {{ newCase.customerReference2 }}
                  </span>
                </div>
                }
                @if (newCase.customerReference3?.length) {
                <div>
                  <label>
                    {{ 'NewCase.CustomerReference' | translate}} 3:
                  </label>
                  <span class="property-value">
                    {{ newCase.customerReference3 }}
                  </span>
                </div>
                }
                @if (newCase.caseRole?.length) {
                <div>
                  <label>
                    {{ 'NewCase.CaseType' | translate}}:
                  </label>
                  <span class="property-value">
                    {{ ('NewCase.' + newCase.caseRole) | translate}}
                  </span>
                </div>
                }
                @if (canAddCustomerReminderFee() && newCase.customerReminderFee) {
                <div>
                  <label>
                    {{ 'NewCase.CustomerReminderFee' | translate}}:
                  </label>
                  <span class="property-value">
                    {{ newCase.customerReminderFee }}
                  </span>
                </div>
                }
                @if (canAddEuFee() && newCase.euFee) {
                <div>
                  <label>
                    {{ 'NewCase.EuFee' | translate}}:
                  </label>
                  <span class="property-value">
                    {{ newCase.euFee }}
                  </span>
                </div>
                }
              </section>
              <h5 class="title">
                {{'NewCase.Claim' | translate}}
              </h5>
              <section class="invoices-summary">
                <div>
                  <label class="label">
                    {{ 'NewCase.Invoice.Number' | translate }}
                  </label>
                  <span *ngFor="let invoice of newCase.invoices" class="property-value">
                    {{ invoice.number }}
                  </span>
                  <label class="label">
                    {{ 'General.Total' | translate }}
                  </label>
                </div>
                <div>
                  <label class="label">
                    {{ 'NewCase.Invoice.Amount' | translate }}
                  </label>
                  <span *ngFor="let invoice of newCase.invoices" class="property-value">
                    {{ invoice.amount | number : locale.numberPipeFormat.style : locale.numberPipeFormat.culture }}
                  </span>
                  <label class="label">
                    {{ invoicesTotal | number : locale.numberPipeFormat.style : locale.numberPipeFormat.culture }}
                  </label>
                </div>
                <div>
                  <label class="label">
                    {{ 'NewCase.Invoice.Date' | translate }}
                  </label>
                  <span *ngFor="let invoice of newCase.invoices" class="property-value">
                    {{ invoice.date | date: locale.datePipeFormat }}
                  </span>
                </div>
                <div>
                  <label class="label">
                    {{ 'NewCase.Invoice.DueDate' | translate }}
                  </label>
                  <span *ngFor="let invoice of newCase.invoices" class="property-value">
                    {{ invoice.dueDate | date: locale.datePipeFormat }}
                  </span>
                </div>
                @if (showInvoiceReminderColumns()) {
                <div>
                  <label class="label">
                    {{ 'NewCase.CustomerReminderFee' | translate }}
                  </label>
                  <span *ngFor="let invoice of newCase.invoices" class="property-value">
                    {{ invoice.customerReminderFee | number : locale.numberPipeFormat.style :
                    locale.numberPipeFormat.culture }}&nbsp;
                  </span>
                </div>
                <div>
                  <label class="label">
                    {{ 'NewCase.Step2.DateOfReminder' | translate }}
                  </label>
                  <span *ngFor="let invoice of newCase.invoices" class="property-value">
                    {{ invoice.customerReminderDueDate | date: locale.datePipeFormat }}&nbsp;
                  </span>
                </div>
                }
                <div>
                  <label class="label">
                    {{ 'NewCase.Invoice.Currency' | translate }}
                  </label>
                  <span *ngFor="let invoice of newCase.invoices" class="property-value">
                    {{ invoice.currencyCode }}
                  </span>
                </div>
                <div>
                  <label>&nbsp;</label>
                  <span *ngFor="let invoice of newCase.invoices" class="property-value">
                    <i class="fas fa-file-alt" [matTooltip]="invoice.invoiceCopyName"
                      (click)="onPreviewCopy(invoice.invoiceCopyName)"></i>
                  </span>
                </div>
              </section>
            </div>
            <div class="summary-tab-right">
              <section class="claim-info-summary">
                <h5 class="title">
                  {{ 'NewCase.Step2.Title' | translate }}
                </h5>
                <div>
                  <label>
                    {{ 'NewCase.ClaimDescription' | translate}}:
                  </label>
                  <span class="property-value">
                    {{ newCase.invoicesDescription }}
                  </span>
                </div>
                @if (displayRoadFreightQuestion()) {
                <div>
                  <label>
                    {{ 'NewCase.IsRoadFreight' | translate}}
                  </label>
                  <span class="property-value">
                    {{ (newCase.isRoadFreight ? 'NewCase.Yes' : 'NewCase.No') | translate }}
                  </span>
                </div>
                }
                <div>
                  <label>
                    {{ 'NewCase.DebtorHasObjections' | translate }}
                  </label>
                  <span class="property-value">
                    {{ (newCase.debtorHasObjections ? 'NewCase.Yes' : 'NewCase.No') | translate }}
                  </span>
                </div>

                @if (!isPerInvoiceReminder()) {
                @if(!newCase.isFirm && newCase.caseRole == 'Collection'){
                <div>
                  <label>
                    {{ 'NewCase.Step2.HasReminderWithPaymentDeadline' | translate }}
                  </label>
                  <span class="property-value">
                    {{ (newCase.debtorHasReminderWithPaymentDeadline ? 'NewCase.Yes' : 'NewCase.No') | translate }}
                  </span>
                </div>

                @if(newCase.debtorHasReminderWithPaymentDeadline){
                <div>
                  <label>
                    {{ 'NewCase.Step2.DateOfReminder' | translate }}
                  </label>
                  <span class="property-value">
                    {{ newCase.dateOfReminder | date: locale.datePipeFormat }}
                  </span>
                </div>

                <div>
                  <label>
                    {{ 'NewCase.Step2.ReminderIncludedFee' | translate }}
                  </label>
                  <span class="property-value">
                    {{ (newCase.debtorHasReminderIncludedFee ? 'NewCase.Yes' : 'NewCase.No') | translate }}
                  </span>
                </div>
                }
                }

                @if(newCase.isFirm && newCase.caseRole == 'Collection'){
                <div>
                  <label>
                    {{ 'NewCase.Step2.HasReminderWithPaymentDeadline' | translate }}
                  </label>
                  <span class="property-value">
                    {{ (newCase.debtorHasReminderWithPaymentDeadline ? 'NewCase.Yes' : 'NewCase.No') | translate }}
                  </span>
                </div>

                @if(newCase.debtorHasReminderWithPaymentDeadline){
                <div>
                  <label class="label">
                    {{ 'NewCase.Step2.DateOfReminder' | translate }}
                  </label>
                  <span class="property-value">
                    {{ newCase.dateOfReminder | date: locale.datePipeFormat }}
                  </span>
                </div>

                @if((newCase.debtorHasReminderWithPaymentDeadline && canReminderIncludeReminderFeeAndEuFee()) ||
                (newCase.debtorHasReminderWithPaymentDeadline && !newCase.hasDebtCollectionNoticeEUFee)){
                <div>
                  <label class="label">
                    {{ 'NewCase.Step2.ReminderIncludedFee' | translate }}
                  </label>
                  <span class="property-value">
                    {{ (newCase.debtorHasReminderIncludedFee ? 'NewCase.Yes' : 'NewCase.No') | translate }}
                  </span>
                </div>
                }

                @if((newCase.debtorHasReminderWithPaymentDeadline && canReminderIncludeReminderFeeAndEuFee()) ||
                (newCase.debtorHasReminderWithPaymentDeadline && !newCase.debtorHasReminderIncludedFee)){
                <div>
                  <label class="label">
                    {{ 'NewCase.Step2.HasDebtCollectionNoticeEUFee' | translate }}
                  </label>
                  <span class="property-value">
                    {{ (newCase.hasDebtCollectionNoticeEUFee ? 'NewCase.Yes' : 'NewCase.No') | translate }}
                  </span>
                </div>
                }
                }
                }
                }

                <div>
                  <label>
                    {{ 'NewCase.Step2.VerificationCheckbox1' | translate}}
                  </label>
                  <span class="property-value">
                    {{ 'NewCase.Yes' | translate }}
                  </span>
                </div>
                @if (!newCase.isFirm) {
                <div>
                  <label>
                    {{ 'NewCase.Step2.VerificationCheckbox2' | translate }}
                  </label>
                  <span class="property-value">
                    {{ 'NewCase.Yes' | translate }}
                  </span>
                </div>
                <div>
                  <label>
                    {{ 'NewCase.Step2.VerificationCheckbox3' | translate }}
                  </label>
                  <span class="property-value">
                    {{ 'NewCase.Yes' | translate }}
                  </span>
                </div>

                @if(newCase.caseRole == 'Collection' && newCase.debtorHasReminderWithPaymentDeadline){
                <div>
                  <label>
                    {{ 'NewCase.Step2.VerificationCheckbox4' | translate }}
                  </label>
                  <span class="property-value">
                    {{ 'NewCase.Yes' | translate }}
                  </span>
                </div>
                }
                }

                @if(newCase.isFirm && newCase.caseRole == 'Reminder'){
                <div>
                  <label>
                    {{ 'NewCase.Step2.ConfirmCapitalMeetsSection9Act' | translate }}
                  </label>
                  <span class="property-value">
                    {{ 'NewCase.Yes' | translate }}
                  </span>
                </div>
                }
              </section>
              <section class="confirmation">
                <label>{{ 'NewCase.Step3.Confirmation' | translate}}</label>
              </section>
            </div>
          </div>
        </div>
        <div>
        </div>
        <div class="buttons-container">
          <button class="button-basic-reverse" type="button" (click)="onNavigateToTab(2)">
            {{ 'NewCase.Previous' | translate }}
          </button>
          <button class="button-basic" type="submit" (click)="onSubmit(form)">
            {{ 'NewCase.CreateCase' | translate }}
          </button>
        </div>
      </section>
    </section>
  </ng-container>

  <section class="recent-cases">
    <app-recently-created-cases></app-recently-created-cases>
  </section>
</form>

<ng-template #errorsDisplay let-c="controll">
  <div [hidden]="c.valid || (!c.touched && !c.dirty)" class="input-error">
    <span>{{ validator.formatControlErrorMessage(c.errors) }}</span>
  </div>
</ng-template>